import { render, staticRenderFns } from "./UploadVideoLibrary.vue?vue&type=template&id=f645da7e&"
import script from "./UploadVideoLibrary.vue?vue&type=script&lang=js&"
export * from "./UploadVideoLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports